import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../firebase/db'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    location: 'nema',
    savedList: [],
    skrol: 0,
    mojList: [],
    id: '',
    aktivan: false,
    user: {
      loggedIn: false,
      data: null
    },
    klID: '0'
  },
  mutations: {
    initialiseStore (state) {
      if (localStorage.getItem('id')) {
        const tmp = JSON.parse(localStorage.getItem('id'))
        state.id = tmp
        db.collection('korpe')
          .doc(tmp.toString())
          .get()
          .then(snapshot => {
            const document = snapshot.data()
            if (document === undefined) {
              this.dispatch('nabaviId')
            }
          })
      } else {
        this.dispatch('nabaviId')
      }
      if (localStorage.getItem('mojList')) {
        state.mojList = JSON.parse(localStorage.getItem('mojList'))
      }
      if (localStorage.getItem('user')) {
        state.user.data = JSON.parse(localStorage.getItem('user'))
      }
      if (localStorage.getItem('loggedIn')) {
        state.user.loggedIn = JSON.parse(localStorage.getItem('loggedIn'))
      }
      if (localStorage.getItem('klID')) {
        state.klID = JSON.parse(localStorage.getItem('klID'))
      }
    },
    setId (state, payload) {
      state.id = payload
    },
    saveList (state, payload) {
      state.savedList = payload
    },
    saveLocation (state, payload) {
      state.location = payload
    },
    saveSkrol (state, payload) {
      state.skrol = payload
    },
    dodMoj (state, payload) {
      var a = search(payload.artikli_id, state.mojList)
      if (a > -1) {
        payload.artikli_kolicina = state.mojList[a].artikli_kolicina + 1
        state.mojList.splice(a, 1)
        state.mojList.push(payload)
      } else {
        payload.artikli_kolicina = 1
        state.mojList.push(payload)
      }

      localStorage.setItem('mojList', JSON.stringify(state.mojList))
      localStorage.setItem('poslato', false)
      localStorage.setItem('zinf', '{}')
    },
    dodMoj2 (state, payload) {
      var a = search(payload.artikli_id, state.mojList)
      if (a > -1) {
        payload.artikli_kolicina = state.mojList[a].artikli_kolicina + 1
        state.mojList.splice(a, 1, payload)
      } else {
        payload.artikli_kolicina = 1
        state.mojList.push(payload)
      }

      localStorage.setItem('mojList', JSON.stringify(state.mojList))
    },
    makniMoj (state, payload) {
      var item = state.mojList[payload]
      var kol = state.mojList[payload].artikli_kolicina
      if (kol > 1) {
        item.artikli_kolicina -= 1
        state.mojList.splice(payload, 1, item)
      } else {
        state.mojList.splice(payload, 1)
      }
      localStorage.setItem('mojList', JSON.stringify(state.mojList))
    },
    clearMoj (state) {
      state.mojList = []
      localStorage.removeItem('mojList')
    },
    SET_LOGGED_IN (state, value) {
      state.user.loggedIn = value
      localStorage.setItem('loggedIn', value)
    },
    SET_USER (state, data) {
      state.user.data = data
      localStorage.setItem('user', JSON.stringify(data))
    },
    setKlid (state, value) {
      state.klID = value
      localStorage.setItem('klID', value)
    }
  },
  actions: {
    clearMoj (state) {
      state.commit('clearMoj')
    },
    saveLocation (state, payload) {
      state.commit('saveLocation', payload)
    },
    saveList (state, payload) {
      state.commit('saveList', payload)
    },
    saveSkrol (state, payload) {
      state.commit('saveSkrol', payload)
    },
    dodMoj (state, payload) {
      state.commit('dodMoj', payload)
    },
    dodMoj2 (state, payload) {
      state.commit('dodMoj2', payload)
    },
    makniMoj (state, payload) {
      state.commit('makniMoj', payload)
    },
    setKlid (state, payload) {
      state.commit('setKlid', payload)
    },
    nabaviId (state) {
      var nmb = Math.floor(100000 + Math.random() * 900000).toString()
      db.collection('korpe')
        .doc(nmb)
        .get()
        .then(snapshot => {
          const document = snapshot.data()
          if (document === undefined) {
            localStorage.setItem('id', nmb)
            db.collection('korpe').doc(nmb).set({
              list: ''
            })
            state.commit('setId', nmb)
          } else {
            this.dispatch('nabaviId')
          }
        })
    },
    fetchUser ({ commit }, user) {
      commit('SET_LOGGED_IN', user !== null)
      if (user) {
        commit('SET_USER', {
          displayName: user.displayName,
          email: user.email
        })
      } else {
        commit('SET_USER', null)
      }
    }
  },
  getters: {
    sList: state => state.savedList,
    sLoc: state => state.location,
    sSkrol: state => state.skrol,
    sMoj: state => state.mojList,
    sId: state => state.id,
    klID: state => state.klID,
    user (state) {
      return state.user
    }
  },
  modules: {
  }
})

function search (idKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    var a = -1
    if (myArray[i].artikli_id === idKey) {
      return i
    }
  }
  return a
}
